/**
 * @generated SignedSource<<2ec6fa471b71ee353094a6efc8ec00c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderSidebar_order$data = {
  readonly cancellationRequestedAt: string | null;
  readonly orderNr: string | null;
  readonly pack: {
    readonly id: string;
  } | null;
  readonly url: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContractDownloadBox_order" | "EntitySidebar_entity">;
  readonly " $fragmentType": "OrderSidebar_order";
};
export type OrderSidebar_order$key = {
  readonly " $data"?: OrderSidebar_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderSidebar_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderSidebar_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderNr",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancellationRequestedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Package",
      "kind": "LinkedField",
      "name": "pack",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContractDownloadBox_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "15ad8ea8637b06355d859099e8107c22";

export default node;
